// import { Navigate, useLocation } from "react-router-dom";
// import ROUTE_CONSTANT from "./routeconstants";
// import { useSelector } from "react-redux";
// const ProtectedRoute = ({ children }) => {
//   const { isAuthenticated, authChecked } = useSelector((state) => state.user);
//   const location = useLocation();

//   if (!authChecked) return null; // or loader

//   if (!isAuthenticated) {
//     return (
//       <Navigate
//         to={ROUTE_CONSTANT.LANDING}
//         replace
//         state={{ from: location }}
//       />
//     );
//   }

//   return children;
// };

// export default ProtectedRoute;



import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ROUTE_CONSTANT from "./routeconstants";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, authChecked } = useSelector(
    (state) => state.user
  );
  const location = useLocation();

  if (!authChecked) return null;

  // 🚫 STOP infinite redirect loop
  if (
    !isAuthenticated &&
    location.pathname !== ROUTE_CONSTANT.LOGIN
  ) {
    return <Navigate to={ROUTE_CONSTANT.LOGIN} replace />;
  }

  return children;
};

export default ProtectedRoute;
